<template>
  <div class="footer-menu" :class="visibleMenu">
    <!-- https://stackoverflow.com/questions/45204191/how-do-you-force-vue-to-show-falsey-attributes-using-v-bind/52395916 -->
    <button class="footer-menu__title" @click="toggleMenu" :aria-expanded="showThisMenu ? 'true' : 'false'" tabindex="-1">
      <h3>
        <a :href="getLink(primaryFooter.link)" class="footer-menu__title-link">{{ primaryFooter.link.title }}</a>
      </h3>
      <font-awesome-icon icon="chevron-down"/>
    </button>
    <section class="footer-menu__content" 
      v-if="primaryFooter.childMenu"
      :aria-hidden="showThisMenu ? 'false' : 'true'">
      <ul class="footer-menu__wrap">
        <li class="footer-menu__menu-item" v-for="link in primaryFooter.childMenu">
          <a :href="getLink(link)" class="footer-menu__link">{{ link.title }}</a>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import mainSite from "@/util/mainSite"

export default {
  name: 'primary-footer-menu',
  mixins: [mainSite],
  props: {
    showAllPrimaryFooterMenus: {
      type: Boolean,
      required: true
    },
    primaryFooter: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    windowWidth: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      mobileMenuClicked: false
    }
  },
  computed: {
    showThisMenu() {
      if(this.showAllPrimaryFooterMenus || this.mobileMenuClicked) {
        return true
      } else {
        return false
      }
    },
    visibleMenu() {
      if(this.showThisMenu) {
        return 'footer-menu--visible footer-menu--open';
      } else if(this.showAllPrimaryFooterMenus) {
        return 'footer-menu--open footer-menu--visible mobile-accordion--closed';
      } else {
        return 'mobile-accordion--closed';
      }
    },
    menuHeight() {
      // If we end up rolling the transition out.. not working right now - but when logged out (e.g. in toggleMenu it works)
      if(this.showThisMenu) {
        let contentHeight = document.getElementsByClassName('footer-menu__wrap');
        contentHeight = contentHeight[this.index];

        return 'height: ' + contentHeight.clientHeight + 'px';
      } else {
        return 'height: 0px';
      }
    }
  },
  methods: {
    toggleMenu() {
      this.mobileMenuClicked = !this.mobileMenuClicked
    },
  }
}
</script>